/**
 * SLIDER
 * @author Alexandre Flatrès, Sandrine M'zé
 * par artwaï pour artwaï
 *
 * JS sur le bloc slider
 */


// ADD class active on the dots of the slider
(function () {
    const dots_container = document.querySelectorAll('.slider-dots')[0];
    const dots_container_display_property = window.getComputedStyle(dots_container).getPropertyValue('display');

    if (dots_container_display_property === 'flex') {
        var links = document.querySelectorAll(".slider-dot");
        links.forEach(function(link) {
            link.addEventListener("click", function(event) {
                var currentActiveLink = document.querySelector(".slider-dot.active");
                if (currentActiveLink) {
                    currentActiveLink.classList.remove("active");
                }
                link.classList.add("active");
            });
        });
    }

}) ();



// ADD navigation behaviour on gallery
const slider_nav = document.querySelectorAll('.slider-nav')[0];
const dots_container = document.querySelectorAll('.slider-dots')[0];
var slider_nav_display_property  = 'none';
var dots_container_display_property = 'none';

if (slider_nav) {
    slider_nav_display_property = window.getComputedStyle(slider_nav).getPropertyValue('display');
}
if (dots_container) {
    dots_container_display_property = window.getComputedStyle(dots_container).getPropertyValue('display');
}

if (slider_nav_display_property === 'flex' || dots_container_display_property === 'flex') {
    const slider_galery = document.querySelectorAll('.slider-container')[0];
    NavBtn(slider_galery);
}
    
function NavBtn(el) {

    const gallery_scrollers = el.querySelectorAll('.slider');
    if(gallery_scrollers.length > 0) {
        var gallery_item_size = el.querySelector('.card').clientWidth;
        gallery_scrollers.forEach((el) => {

            var gallery_items = el.querySelectorAll('.card-carousel');
            var gallery_scroller = el;
            var gallery_prev = el.querySelector('.slider-nav .prev');
            var gallery_next = el.querySelector('.slider-nav .next');
            var gallery_dots = document.querySelector('.slider-dots');

            gallery_prev = !gallery_prev ? el.parentElement.querySelector('.slider-nav .prev') : gallery_prev; 
            gallery_next = !gallery_next ? el.parentElement.querySelector('.slider-nav .next') : gallery_next;
            
            if(gallery_prev && gallery_next) {
                gallery_prev.addEventListener('click', scrollToPrevPage, false);
                gallery_next.addEventListener('click', scrollToNextPage, false);
                
                var timer = null;
                gallery_scroller.addEventListener("scroll", function() {
                    if(timer !== null) {
                        clearTimeout(timer);        
                    }
                    timer = setTimeout(function() {
                        // scrolled end (+2 for problem on slide next click)
                        if ((gallery_scroller.offsetWidth + gallery_scroller.scrollLeft + 2) >= gallery_scroller.scrollWidth) {
                            gallery_next.setAttribute('disabled', 'disabled');
                            gallery_prev.removeAttribute('disabled');
                        } else {
                            gallery_next.removeAttribute('disabled');
                        }

                        if (gallery_scroller.scrollLeft == 0 || gallery_scroller.scrollLeft < gallery_item_size - 10) { // gallery_scroller.scrollLeft <= gallery_item_size
                            gallery_prev.setAttribute('disabled', 'disabled');
                            gallery_next.removeAttribute('disabled');
                        } else {
                            gallery_prev.removeAttribute('disabled');
                        }
                    }, 300);
                });
            }

            if(gallery_dots) {
                var observer = new IntersectionObserver(function(entries, observer) {
                    // find the entry with the largest intersection ratio
                    /*var activated = entries.reduce(function (max, entry) {
                        return (entry.intersectionRatio > max.intersectionRatio) ? entry : max;
                    });*/

                    /*if (activated.intersectionRatio > 0.5) {
                        currentIndex = elementIndices[activated.target.getAttribute("id")];
                        renderDots(gallery_dots);
                    }*/
                    entries.forEach((entry) => {
                        if(entry.isIntersecting) {
                            currentIndex = elementIndices[entry.target.getAttribute("id")];
                            renderDots(gallery_dots);
                        }
                    });
                    
                }, {
                    root:gallery_scroller, threshold:0.5
                });

                var elementIndices = {};
                for (var i = 0; i < gallery_items.length; i++) {


                    gallery_dots.children[i].addEventListener("click", function(evt){
                        evt.preventDefault();

                        var anchor = document.getElementById(this.getAttribute('href').substring(1));
                        var anchorHorizontalPosition = anchor.getBoundingClientRect().left;

                        // scroll horizontal
                        window.scrollTo({
                            top: gallery_scroller.getBoundingClientRect().top + window.scrollY - 160,
                        });

                        // scroll vertical
                        anchor.parentElement.scrollTo({
                            left: anchorHorizontalPosition
                        })
                    });

                    elementIndices[gallery_items[i].getAttribute("id")] = i;
                    observer.observe(gallery_items[i]);
                }
            }

            el.classList.add('loaded');

            function renderDots(gallery_dots) {
                for (var i = 0; i < gallery_items.length; i++) {
                    gallery_dots.children[i].classList.remove('active');
                    if(i === currentIndex) {
                        gallery_dots.children[i].classList.add('active');
                    }
                }
            }
            function scrollToPrevPage(evt) {
                evt.preventDefault();
                gallery_scroller.scrollBy(-gallery_item_size, 0);
                gallery_next.removeAttribute('disabled');
            }
            function scrollToNextPage(evt) {
                evt.preventDefault();
                gallery_scroller.scrollBy(gallery_item_size, 0);
                gallery_prev.removeAttribute('disabled');
            }

        });
    }
}